export default __webpack_public_path__ + "static/logo-420f6849a43c556dd1ad4c3d2699140c.png";